var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 6c0-3.312-2.688-6-6-6H6C2.688 0 0 2.688 0 6v36c0 3.312 2.688 6 6 6h36c3.312 0 6-2.688 6-6V6z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.765 16.75h-8.04v24.184h8.04V16.75zM9.798 5.089c-2.75 0-4.548 1.808-4.548 4.179 0 2.32 1.743 4.178 4.442 4.178h.052c2.803 0 4.548-1.858 4.548-4.178-.052-2.37-1.745-4.18-4.494-4.18zM33.495 16.182c-4.264 0-6.174 2.345-7.244 3.992V16.75h-8.038c.107 2.269 0 24.184 0 24.184h8.038V27.428c0-.723.052-1.445.265-1.962.58-1.444 1.903-2.94 4.124-2.94 2.907 0 4.072 2.22 4.072 5.469v12.94h8.038v-13.87c0-7.428-3.966-10.883-9.255-10.883z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIN.6362be347c34a41662a5fac2c3cf784a.svg";
export { ForwardRef as ReactComponent };